<template>
<div class="post-moderation">
    <label class="label">Post Moderation</label>
    <Checkbox
        :value="$attrs.filterProfanity"
        @input="$emit('update:filterProfanity', $event)">
        Automatically block posts that contain profanity.
    </Checkbox>
    <div class="help">
        <p>
            Posts are <u>always</u> verified with
            <a :href="autoModUrl" target="_blank">AutoMod</a>.
            Set up AutoMod to protect your channel.<br>
        </p>
    </div>

    <Checkbox
        :value="$attrs.requireApproval"
        @input="$emit('update:requireApproval', $event)">
        Require posts to be approved.
    </Checkbox>
    <div class="help">
        <p>
            By default, posts are publicly readable.<br>
            Enable this option if you want posts to be approved
            by you or a moderator before going public.
        </p>
    </div>

    <Checkbox
        :value="$attrs.allowModAdmin"
        @input="$emit('update:allowModAdmin', $event)">
        Allow chat moderators to approve and delete posts.
    </Checkbox>
    <p class="help">
        Moderators must grant this extension their Twitch User ID.
    </p>

    <Checkbox
        :value="$attrs.allowLinks"
        @input="$emit('update:allowLinks', $event)">
        Allow posts with links.
    </Checkbox>
    <p class="help">
        If this option is disabled, posts that contain links will be blocked.<br>
        Note that it is simple to post links in a way that code can't detect,
        but people can.
    </p>

    <Checkbox
        :value="$attrs.revealLinkPreview"
        @input="$emit('update:revealLinkPreview', $event)">
        Display link preview content by default.
    </Checkbox>
    <p class="help">
        Normally, most link previews must be clicked to reveal content.<br>
        Remember that NSFW websites exist, and <b>you are responsible</b> for
        all content that appears on your channel.<br>
        <a @click="demoLinkPreview">Click here</a> to see a link preview demo,
        then toggle the checkbox to see the difference.
    </p>
</div>
</template>

<script>
import * as M from '@/store/mutations'

export default {
    name: 'PostModeration',
    inheritAttrs: false,
    data: () => ({
        autoModUrl: 'https://help.twitch.tv/s/article/how-to-use-automod'
    }),
    methods: {
        demoLinkPreview () {
            this.$store.commit(M.DEMO_LINK_PREVIEW)
        }
    }
}
</script>

<style lang="scss" scoped>
.help {
    margin-bottom: 1.5rem;
}
</style>
